import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SalesTeam } from '../_models/sales-team.model';
import { HttpUtilsService, QueryParamsModel, QueryResultsModel } from '../../_base/crud';
import { environment } from 'src/environments/environment';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import { currentAuthToken, currentUser } from '../../auth';

@Injectable({ providedIn: 'root' })
export class SalesTeamService {
  private authToken;
  private companyId;

  constructor(
    private httpClient: HttpClient,
    private store: Store<AppState>,
    private httpUtils: HttpUtilsService,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  createSalesTeam(_salesTeam: SalesTeam) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.post<SalesTeam>(
      environment.USER_BASE + '/companies/' + this.companyId + '/sales_teams',
      _salesTeam,
      {
        headers: httpHeaders,
      },
    );
  }

  updateSalesTeam(_salesTeam: SalesTeam, id): Observable<any> {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.put<SalesTeam>(
      environment.USER_BASE + '/companies/' + this.companyId + '/sales_teams/' + id,
      _salesTeam,
      {
        headers: httpHeaders,
      },
    );
  }

  deleteSalesTeam(id?: number) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.delete<any>(
      environment.USER_BASE + '/companies/' + this.companyId + '/sales_teams/' + id,
      { headers: httpHeaders },
    );
  }

  findSalesTeams(queryParams: QueryParamsModel): Observable<any> {
    const pageSize = queryParams.pageSize;
    const pageIndex = queryParams.pageNumber;
    const filters = queryParams.filter;
    const headers = this.httpUtils.getHTTPHeaders(this.authToken);
    const params = new HttpParams({
      fromString:
        '&page=' +
        pageIndex +
        '&size=' +
        pageSize +
        '&search_term=' +
        filters.searchData +
        '&manager_id=' +
        filters.manager_id +
        '&type=' +
        filters.type +
        '&calls_on=' +
        filters.calls_on +
        '&entity_id=' +
        filters.entitySideObject,
    });
    return this.httpClient.get<QueryResultsModel>(
      environment.USER_BASE + '/companies/' + this.companyId + '/sales_teams',
      { headers, params },
    );
  }

  getTargetList(id, type) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    return this.httpClient.get<any>(
      environment.CORE_BASE +
        '/companies/' +
        this.companyId +
        '/entities/get-by-sales-teams-criteria?' +
        type +
        '=' +
        id,
      {
        headers: httpHeaders,
      },
    );
  }
}
